module.exports = __webpack_public_path__ + "static/media/back_slash.d63485db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/back_slash.svg
// module id = 211
// module chunks = 1